import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { debounceTime, filter, map } from 'rxjs/operators';

import { ContentObserver } from '@angular/cdk/observers';
import { shareRef } from '../../operators/share-ref.operator';
import { CanSetSize } from './equal-size.models';

@Injectable()
export class EqualSizeService {
  items: Record<string, CanSetSize[]> = {};

  private refresh$ = new BehaviorSubject<undefined | string>(void 0);

  private update$: Record<string, Observable<number>> = {};

  constructor(private co: ContentObserver) {}

  registerItem(item: CanSetSize): Observable<number> {
    if (!this.items[item.axis]) {
      this.items[item.axis] = [];
      this.update$[item.axis] = this.refresh$.pipe(
        filter((category) => category === item.axis),
        debounceTime(1),
        map(() => this.getSize(this.items[item.axis] || [])),
        shareRef(),
      );
    }

    if (!this.items[item.axis].includes(item)) {
      this.co.observe(item.el).subscribe((event) => this.refresh$.next(item.axis));

      this.items[item.axis].push(item);
    }

    this.refresh$.next(item.axis);

    return this.update$[item.axis];
  }

  unregisterItem(item: CanSetSize): void {
    const idx = this.items[item.axis]?.indexOf(item);

    if (idx > -1) {
      this.items[item.axis]?.splice(idx, 1);
    }

    this.refresh$.next(item.axis);
  }

  private getSize(items: CanSetSize[]): number {
    items.forEach((item) => (item.el.nativeElement.style[item.axis] = ''));

    return items.reduce((a, { el: { nativeElement }, axis }) => {
      const size = axis === 'width' ? nativeElement.offsetWidth : nativeElement.offsetHeight;

      return a < size ? size : a;
    }, 0);
  }
}
